module.exports = __webpack_public_path__ + "static/img/cont66 (1).a415362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont66 (1).jpg
// module id = fIaJ
// module chunks = 0